/**
 * Airbox Selector - Handles adding complementary products to cart
 */
class AirboxSelector {
  constructor() {
    this.selectors = document.querySelectorAll('.airbox-selector');
    this.isAdding = false;

    console.log('[AirboxSelector] Initializing...');
    console.log('[AirboxSelector] Found', this.selectors.length, 'selector(s) on page');

    if (this.selectors.length === 0) {
      console.log('[AirboxSelector] No airbox selectors found - exiting');
      return;
    }

    // Log each selector's radio buttons for debugging
    this.selectors.forEach((selector, index) => {
      const radios = selector.querySelectorAll('input[type="radio"]');
      console.log(`[AirboxSelector] Selector ${index + 1}:`, radios.length, 'radio options');
      radios.forEach(radio => {
        console.log('  - Radio:', radio.value, 'variantId:', radio.dataset.variantId, 'available:', radio.dataset.available);
      });
    });

    this.init();
  }

  init() {
    // Listen for the cart add event using the theme's pub/sub system
    // Note: product-form publishes cartUpdate, but global.js converts it to cartAdd
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      console.log('[AirboxSelector] subscribe and PUB_SUB_EVENTS are available');
      console.log('[AirboxSelector] Subscribing to', PUB_SUB_EVENTS.cartAdd);

      subscribe(PUB_SUB_EVENTS.cartAdd, (data) => {
        this.handleCartUpdate(data);
      });

      console.log('[AirboxSelector] Successfully subscribed to cart add events');
    } else {
      console.error('[AirboxSelector] PUB_SUB_EVENTS or subscribe not available!');
      console.log('[AirboxSelector] subscribe:', typeof subscribe);
      console.log('[AirboxSelector] PUB_SUB_EVENTS:', typeof PUB_SUB_EVENTS);
    }
  }

  handleCartUpdate(data) {
    console.log('[AirboxSelector] ========================================');
    console.log('[AirboxSelector] Cart update event received!');
    console.log('[AirboxSelector] Event data:', data);
    console.log('[AirboxSelector] isAdding flag:', this.isAdding);

    // Only proceed if we're not already adding a product
    if (this.isAdding) {
      console.log('[AirboxSelector] Already adding a product, skipping...');
      return;
    }

    // Find the active selector
    this.selectors.forEach((selector, index) => {
      console.log(`[AirboxSelector] Processing selector ${index + 1}`);
      this.addComplementaryProduct(selector);
    });
  }

  async addComplementaryProduct(selector) {
    const selectedRadio = selector.querySelector('input[type="radio"]:checked');

    console.log('[AirboxSelector] Selected radio:', selectedRadio);
    console.log('[AirboxSelector] Selected radio value:', selectedRadio?.value);

    // If "No, thanks" is selected or no radio is checked, do nothing
    if (!selectedRadio || selectedRadio.value === 'none') {
      console.log('[AirboxSelector] No complementary product selected (or "No, thanks" selected) - skipping');
      return;
    }

    const complementaryVariantId = selectedRadio.dataset.variantId;
    const complementaryAvailable = selectedRadio.dataset.available === 'true';

    console.log('[AirboxSelector] Complementary variant ID:', complementaryVariantId);
    console.log('[AirboxSelector] Complementary available:', complementaryAvailable);

    if (!complementaryVariantId) {
      console.error('[AirboxSelector] No variant ID found on selected radio!');
      return;
    }

    if (!complementaryAvailable) {
      console.warn('[AirboxSelector] Complementary product not available - skipping');
      return;
    }

    // Set flag to prevent duplicate adds
    this.isAdding = true;
    console.log('[AirboxSelector] Setting isAdding = true');

    try {
      console.log('[AirboxSelector] Attempting to add complementary product...');
      console.log('[AirboxSelector] Variant ID:', complementaryVariantId);
      console.log('[AirboxSelector] Fetching:', window.Shopify.routes.root + 'cart/add.js');

      // Add the complementary product
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [
            {
              id: parseInt(complementaryVariantId, 10),
              quantity: 1
            }
          ]
        })
      });

      console.log('[AirboxSelector] Response status:', response.status);
      console.log('[AirboxSelector] Response OK:', response.ok);

      if (response.ok) {
        const result = await response.json();
        console.log('[AirboxSelector] ✓ Complementary product added successfully!');
        console.log('[AirboxSelector] Response:', result);

        // Give the cart drawer/notification time to render the main product first, then refresh
        setTimeout(async () => {
          try {
            const cartDrawer = document.querySelector('cart-drawer');
            const cartNotification = document.querySelector('cart-notification');

            console.log('[AirboxSelector] Cart drawer element:', cartDrawer);
            console.log('[AirboxSelector] Cart notification element:', cartNotification);

            // Collect all sections we need to fetch
            let allSections = [];

            if (cartDrawer && cartDrawer.getSectionsToRender) {
              allSections = [...allSections, ...cartDrawer.getSectionsToRender().map(s => s.id)];
            }

            if (cartNotification && cartNotification.getSectionsToRender) {
              allSections = [...allSections, ...cartNotification.getSectionsToRender().map(s => s.id)];
            }

            // Remove duplicates
            allSections = [...new Set(allSections)];

            console.log('[AirboxSelector] Fetching sections:', allSections);

            // Fetch updated sections using Shopify's section rendering API
            const sectionsUrl = `${window.location.pathname}?sections=${allSections.join(',')}`;
            console.log('[AirboxSelector] Sections URL:', sectionsUrl);

            const sectionsResponse = await fetch(sectionsUrl);
            const sectionsData = await sectionsResponse.json();
            console.log('[AirboxSelector] Sections response:', sectionsData);

            // Wrap in the format expected by renderContents
            const wrappedData = {
              sections: sectionsData
            };

            // Update cart drawer if it exists and is open/should open
            if (cartDrawer && typeof cartDrawer.renderContents === 'function' && sectionsData) {
              console.log('[AirboxSelector] Updating cart drawer with new data');
              cartDrawer.renderContents(wrappedData, true); // preventOpen = true
            }

            // Update cart notification to show both products
            if (cartNotification && sectionsData['cart-notification-product']) {
              const notificationElement = document.getElementById('cart-notification');
              const isNotificationVisible = notificationElement && notificationElement.classList.contains('active');

              console.log('[AirboxSelector] Cart notification visible:', isNotificationVisible);

              if (isNotificationVisible && result.items && result.items.length > 0) {
                console.log('[AirboxSelector] Adding airbox product to notification display');

                // Parse the full cart notification product HTML (contains all items)
                const parser = new DOMParser();
                const doc = parser.parseFromString(sectionsData['cart-notification-product'], 'text/html');

                // Get the airbox product HTML (the item we just added)
                const airboxItemKey = result.items[0].key;
                const airboxProductHtml = doc.querySelector(`[id="cart-notification-product-${airboxItemKey}"]`);

                console.log('[AirboxSelector] Airbox item key:', airboxItemKey);
                console.log('[AirboxSelector] Airbox product HTML found:', !!airboxProductHtml);

                if (airboxProductHtml) {
                  // Find the notification product container
                  const notificationProductSection = document.getElementById('shopify-section-cart-notification-product');

                  if (notificationProductSection) {
                    // Append the airbox product HTML (don't replace, just add)
                    console.log('[AirboxSelector] Appending airbox product to notification');
                    notificationProductSection.appendChild(airboxProductHtml.cloneNode(true));
                  }
                }

                // Update the cart notification button to show correct count
                if (sectionsData['cart-notification-button']) {
                  const notificationButtonSection = document.getElementById('shopify-section-cart-notification-button');
                  if (notificationButtonSection) {
                    console.log('[AirboxSelector] Updating notification button count');
                    const buttonDoc = parser.parseFromString(sectionsData['cart-notification-button'], 'text/html');
                    const newButton = buttonDoc.querySelector('.shopify-section');
                    if (newButton) {
                      notificationButtonSection.innerHTML = newButton.innerHTML;
                    }
                  }
                }
              } else {
                console.log('[AirboxSelector] Notification not visible, skipping update');
              }
            }

            // Publish cart update event so other components know cart changed
            if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
              console.log('[AirboxSelector] Publishing cartUpdate event for complementary product');
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'airbox-selector',
                cartData: wrappedData
              });
            }
          } catch (error) {
            console.error('[AirboxSelector] Error refreshing cart UI:', error);
            console.error('[AirboxSelector] Error stack:', error.stack);
          }
        }, 500);

      } else {
        const errorData = await response.json();
        console.error('[AirboxSelector] ✗ Failed to add complementary product');
        console.error('[AirboxSelector] Error response:', errorData);
      }
    } catch (error) {
      console.error('[AirboxSelector] ✗ Exception while adding complementary product:', error);
    } finally {
      console.log('[AirboxSelector] Setting isAdding = false');
      this.isAdding = false;

      // Reset the selector back to "No, thanks" for next add to cart
      setTimeout(() => {
        const noThanksRadio = selector.querySelector('input[value="none"]');
        if (noThanksRadio) {
          console.log('[AirboxSelector] Resetting selector to "No, thanks"');
          noThanksRadio.checked = true;
        }
      }, 1000);
    }
  }

}

// Global instance to prevent duplicate subscriptions
window.airboxSelectorInstance = null;

// Initialize when DOM is ready
function initAirboxSelector() {
  try {
    console.log('[AirboxSelector] initAirboxSelector() called');

    // Prevent duplicate instances
    if (window.airboxSelectorInstance) {
      console.log('[AirboxSelector] Instance already exists, skipping initialization');
      return;
    }

    window.airboxSelectorInstance = new AirboxSelector();
  } catch (error) {
    console.error('[AirboxSelector] Error initializing:', error);
  }
}

try {
  if (document.readyState === 'loading') {
    console.log('[AirboxSelector] Document still loading, waiting for DOMContentLoaded...');
    document.addEventListener('DOMContentLoaded', initAirboxSelector);
  } else {
    console.log('[AirboxSelector] Document already loaded, initializing immediately');
    initAirboxSelector();
  }

  // Re-initialize on section load (for theme editor)
  document.addEventListener('shopify:section:load', () => {
    console.log('[AirboxSelector] Section loaded in theme editor');
    window.airboxSelectorInstance = null; // Allow re-initialization
    initAirboxSelector();
  });
} catch (error) {
  console.error('[AirboxSelector] Error setting up initialization:', error);
}
